export default __webpack_public_path__ + "static/sustainble-cities-and-communities-0dd24f7386a52b7801364e82250ccc23.png";